// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../img/bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  border: 0 none;
  font: inherit;
  margin: 0;
  padding: 0;
  vertical-align: baseline;
}
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}
body {
  line-height: 1;
}
ol,
ul {
  list-style: outside none none;
}
blockquote,
q {
  quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
button::-moz-focus-inner {
  border: 0 none;
  margin: 0;
  padding: 0;
}
*,
*:before,
*:after {
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
html,
body {
  font: 16px/24px "Open Sans";
  color: #212121;
  width: 100%;
  min-height: 100%;
  position: relative;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
input,
textarea,
select {
  font: 16px/24px "Open Sans";
}
a {
  text-decoration: none;
  color: #757575;
  transition: color 450ms cubic-bezier(0.23, 1, 0.32, 1);
}
a:hover {
  color: #8BC34A;
}
h1 {
  font-size: 24px;
  line-height: 32px;
  color: #212121;
  margin: 0;
}
h2 {
  font-size: 22px;
  line-height: 30px;
  color: #212121;
  margin: 0;
}
h3 {
  font-size: 20px;
  line-height: 28px;
  color: #212121;
  font-weight: 600;
  margin: 0;
}
p {
  margin: 16px 0;
}
ul {
  list-style: outside;
  padding-left: 20px;
  margin: 8px 0;
}
b {
  font-weight: 600;
}
.clear {
  clear: both;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.center-text {
  text-align: center !important;
}
.text-center {
  text-align: center !important;
}
.text-left {
  text-align: left !important;
}
.text-right {
  text-align: right !important;
}
.align-top {
  vertical-align: top !important;
}
.align-middle {
  vertical-align: middle !important;
}
.align-bottom {
  vertical-align: bottom !important;
}
.no-margin {
  margin: 0 !important;
}
.no-padding {
  padding: 0 !important;
}
.no-wrap {
  text-wrap: none;
  white-space: -moz-nowrap;
  white-space: nowrap;
  word-wrap: normal;
}
.inline {
  display: inline-block;
}
.hidden {
  display: none !important;
}
.no-scroll {
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}
.margin-1 {
  margin: 8px !important;
}
.margin-left-1 {
  margin-left: 8px !important;
}
.margin-right-1 {
  margin-right: 8px !important;
}
.margin-top-1 {
  margin-top: 8px !important;
}
.margin-bottom-1 {
  margin-bottom: 8px !important;
}
.margin-2 {
  margin: 16px !important;
}
.margin-left-2 {
  margin-left: 16px !important;
}
.margin-right-2 {
  margin-right: 16px !important;
}
.margin-top-2 {
  margin-top: 16px !important;
}
.margin-bottom-2 {
  margin-bottom: 16px !important;
}
.margin-3 {
  margin: 24px !important;
}
.margin-left-3 {
  margin-left: 24px !important;
}
.margin-right-3 {
  margin-right: 24px !important;
}
.margin-top-3 {
  margin-top: 24px !important;
}
.margin-bottom-3 {
  margin-bottom: 24px !important;
}
.margin-4 {
  margin: 32px !important;
}
.margin-left-4 {
  margin-left: 32px !important;
}
.margin-right-4 {
  margin-right: 32px !important;
}
.margin-top-4 {
  margin-top: 32px !important;
}
.margin-bottom-4 {
  margin-bottom: 32px !important;
}
.w-short {
  width: 80px !important;
}
.w-middle {
  width: 160px !important;
}
.w-long {
  width: 240px !important;
}
.w-x-long {
  width: 320px !important;
}
.w-wide {
  width: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/less/cssReset.less","webpack://./src/components/Application/less/index.less","webpack://./src/less/mixins.less"],"names":[],"mappings":"AACI;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EACI,cAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,wBAAA;ACgFR;AD9EI;;;;;;;;;;;EACI,cAAA;AC0FR;ADxFI;EACI,cAAA;AC0FR;ADxFI;;EACI,6BAAA;AC2FR;ADzFI;;EACI,YAAA;AC4FR;AD1FI;;;;EACI,aAAA;AC+FR;AD7FI;EACI,yBAAA;EACA,iBAAA;AC+FR;AD7FI;EACI,cAAA;EACA,SAAA;EACA,UAAA;AC+FR;AD3FI;;;EEsGA,2BAAA;EACA,8BAAA;EACA,sBAAA;ADNJ;AA9HA;;EACI,2BAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mDAAA;AAiIJ;AA9HA;;;EACI,2BAAA;AAkIJ;AA/HA;EACI,qBAAA;EACA,cAAA;EACA,sDAAA;AAiIJ;AA/HI;EACI,cAAA;AAiIR;AA7HA;EAEI,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AA8HJ;AA3HA;EAEI,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AA4HJ;AAzHA;EAEI,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;AA0HJ;AAvHA;EACI,cAAA;AAyHJ;AAtHA;EACI,mBAAA;EACA,kBAAA;EACA,aAAA;AAwHJ;AArHA;EACI,gBAAA;AAuHJ;AApHA;EACI,WAAA;AAsHJ;AAnHA;ECkSI,cAAA;EACA,iBAAA;EACA,kBAAA;AD5KJ;AApHA;EACI,6BAAA;AAsHJ;AAnHA;EACI,6BAAA;AAqHJ;AAlHA;EACI,2BAAA;AAoHJ;AAjHA;EACI,4BAAA;AAmHJ;AAhHA;EACI,8BAAA;AAkHJ;AA/GA;EACI,iCAAA;AAiHJ;AA9GA;EACI,iCAAA;AAgHJ;AA7GA;EACI,oBAAA;AA+GJ;AA5GA;EACI,qBAAA;AA8GJ;AA3GA;ECiBI,eAAA;EACA,wBAAA;EACA,mBAAA;EACA,iBAAA;AD6FJ;AA7GA;EACI,qBAAA;AA+GJ;AA5GA;EACI,wBAAA;AA8GJ;AA3GA;EACI,6BAAA;EACA,6BAAA;AA6GJ;AA1GA;EACI,sBAAA;AA4GJ;AAzGA;EACI,2BAAA;AA2GJ;AAxGA;EACI,4BAAA;AA0GJ;AAvGA;EACI,0BAAA;AAyGJ;AAtGA;EACI,6BAAA;AAwGJ;AArGA;EACI,uBAAA;AAuGJ;AApGA;EACI,4BAAA;AAsGJ;AAnGA;EACI,6BAAA;AAqGJ;AAlGA;EACI,2BAAA;AAoGJ;AAjGA;EACI,8BAAA;AAmGJ;AAhGA;EACI,uBAAA;AAkGJ;AA/FA;EACI,4BAAA;AAiGJ;AA9FA;EACI,6BAAA;AAgGJ;AA7FA;EACI,2BAAA;AA+FJ;AA5FA;EACI,8BAAA;AA8FJ;AA3FA;EACI,uBAAA;AA6FJ;AA1FA;EACI,4BAAA;AA4FJ;AAzFA;EACI,6BAAA;AA2FJ;AAxFA;EACI,2BAAA;AA0FJ;AAvFA;EACI,8BAAA;AAyFJ;AAtFA;EACI,sBAAA;AAwFJ;AArFA;EACI,uBAAA;AAuFJ;AApFA;EACI,uBAAA;AAsFJ;AAnFA;EACI,uBAAA;AAqFJ;AAlFA;EACI,sBAAA;AAoFJ","sourcesContent":["#css-reset() {\n    html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video {\n        border: 0 none;\n        font: inherit;\n        margin: 0;\n        padding: 0;\n        vertical-align: baseline;\n    }\n    article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section {\n        display: block;\n    }\n    body {\n        line-height: 1;\n    }\n    ol, ul {\n        list-style: outside none none;\n    }\n    blockquote, q {\n        quotes: none;\n    }\n    blockquote:before, blockquote:after, q:before, q:after {\n        content: none;\n    }\n    table {\n        border-collapse: collapse;\n        border-spacing: 0;\n    }\n    button::-moz-focus-inner {\n        border: 0 none;\n        margin: 0;\n        padding: 0;\n    }\n\n\n    *, *:before, *:after {\n        .box-sizing();\n    }\n}","@import (reference) \"../../../less/variables\";\n@import (reference) \"../../../less/mixins\";\n@import (reference) \"../../../less/cssReset\";\n\n#css-reset();\n\nhtml, body {\n    font: ~'@{tsNormal}/@{tlNormal} \"@{font-family}\"';\n    color: @tPrimary;\n    width: 100%;\n    min-height: 100%;\n    position: relative;\n    background: url(\"../../../img/bg.png\");\n}\n\ninput, textarea, select {\n    font: ~'@{tsNormal}/@{tlNormal} \"@{font-family}\"';\n}\n\na {\n    text-decoration: none;\n    color: @tSecondary;\n    transition: color @transition-duration @transition-function;\n\n    &:hover {\n        color: @tAccent;\n    }\n}\n\nh1 {\n    // 24\n    font-size: @tsXXLarge;\n    line-height: @tlXXLarge;\n    color: @tPrimary;\n    margin: 0;\n}\n\nh2 {\n    // 22\n    font-size: @tsXLarge;\n    line-height: @tlXLarge;\n    color: @tPrimary;\n    margin: 0;\n}\n\nh3 {\n    // 20\n    font-size: @tsLarge;\n    line-height: @tlLarge;\n    color: @tPrimary;\n    font-weight: @twSemi;\n    margin: 0;\n}\n\np {\n    margin: @gutter*2 0;\n}\n\nul {\n    list-style: outside;\n    padding-left: @gutter*2.5;\n    margin: @gutter 0;\n}\n\nb {\n    font-weight: @twSemi;\n}\n\n.clear {\n    clear: both;\n}\n\n.center {\n    .center-block();\n}\n\n.center-text {\n    text-align: center !important;\n}\n\n.text-center {\n    text-align: center !important;\n}\n\n.text-left {\n    text-align: left !important;\n}\n\n.text-right {\n    text-align: right !important;\n}\n\n.align-top {\n    vertical-align: top !important;\n}\n\n.align-middle {\n    vertical-align: middle !important;\n}\n\n.align-bottom {\n    vertical-align: bottom !important;\n}\n\n.no-margin {\n    margin: 0 !important;\n}\n\n.no-padding {\n    padding: 0 !important;\n}\n\n.no-wrap {\n    .no-wrap();\n}\n\n.inline {\n    display: inline-block;\n}\n\n.hidden {\n    display: none !important;\n}\n\n.no-scroll {\n    overflow-y: hidden !important;\n    overflow-x: hidden !important;\n}\n\n.margin-1 {\n    margin: @gutter !important;\n}\n\n.margin-left-1 {\n    margin-left: @gutter !important;\n}\n\n.margin-right-1 {\n    margin-right: @gutter !important;\n}\n\n.margin-top-1 {\n    margin-top: @gutter !important;\n}\n\n.margin-bottom-1 {\n    margin-bottom: @gutter !important;\n}\n\n.margin-2 {\n    margin: @gutter*2 !important;\n}\n\n.margin-left-2 {\n    margin-left: @gutter*2 !important;\n}\n\n.margin-right-2 {\n    margin-right: @gutter*2 !important;\n}\n\n.margin-top-2 {\n    margin-top: @gutter*2 !important;\n}\n\n.margin-bottom-2 {\n    margin-bottom: @gutter*2 !important;\n}\n\n.margin-3 {\n    margin: @gutter*3 !important;\n}\n\n.margin-left-3 {\n    margin-left: @gutter*3 !important;\n}\n\n.margin-right-3 {\n    margin-right: @gutter*3 !important;\n}\n\n.margin-top-3 {\n    margin-top: @gutter*3 !important;\n}\n\n.margin-bottom-3 {\n    margin-bottom: @gutter*3 !important;\n}\n\n.margin-4 {\n    margin: @gutter*4 !important;\n}\n\n.margin-left-4 {\n    margin-left: @gutter*4 !important;\n}\n\n.margin-right-4 {\n    margin-right: @gutter*4 !important;\n}\n\n.margin-top-4 {\n    margin-top: @gutter*4 !important;\n}\n\n.margin-bottom-4 {\n    margin-bottom: @gutter*4 !important;\n}\n\n.w-short {\n    width: @gutter*10 !important;\n}\n\n.w-middle {\n    width: @gutter*20 !important;\n}\n\n.w-long {\n    width: @gutter*30 !important;\n}\n\n.w-x-long {\n    width: @gutter*40 !important;\n}\n\n.w-wide {\n    width: 100% !important;\n}","@import (reference) \"./variables\";\n\n.border-top-radius(@radius) {\n    border-top-right-radius: @radius;\n    border-top-left-radius: @radius;\n}\n.border-right-radius(@radius) {\n    border-bottom-right-radius: @radius;\n    border-top-right-radius: @radius;\n}\n.border-bottom-radius(@radius) {\n    border-bottom-right-radius: @radius;\n    border-bottom-left-radius: @radius;\n}\n.border-left-radius(@radius) {\n    border-bottom-left-radius: @radius;\n    border-top-left-radius: @radius;\n}\n\n.gradient(@top: #f9f9f9, @bottom: #dddddd) {\n    background: @top/2 + @bottom/2;\n    background: ~\"-webkit-gradient(linear, left top, left bottom, from(@{top}), to(@{bottom}))\";\n    background: ~\"-moz-linear-gradient(top, @{top}, @{bottom})\";\n    background: ~\"-o-linear-gradient(top, @{top} 0%, @{bottom} 100%)\";\n    background: ~\"-ms-linear-gradient(top, @{top}, @{bottom})\";\n    background: ~\"linear-gradient(top, @{top}, @{bottom})\";\n    filter: ~\"progid:DXImageTransform.Microsoft.Gradient(startColorstr='@{top}', endColorstr='@{bottom}')\";\n}\n\n.text-transform(@val: none) {\n    -webkit-text-transform: @val;\n    -moz-text-transform: @val;\n    -o-text-transform: @val;\n    -ms-text-transform: @val;\n    text-transform: @val;\n}\n\n.transform(@val: none) {\n    -webkit-transform: @val;\n    -moz-transform: @val;\n    -o-transform: @val;\n    -ms-transform: @val;\n    transform: @val;\n}\n\n.animation(@animation) {\n    -webkit-animation: @animation;\n    animation: @animation;\n}\n.animation-name(@name) {\n    -webkit-animation-name: @name;\n    animation-name: @name;\n}\n.animation-duration(@duration) {\n    -webkit-animation-duration: @duration;\n    animation-duration: @duration;\n}\n.animation-timing-function(@timing-function) {\n    -webkit-animation-timing-function: @timing-function;\n    animation-timing-function: @timing-function;\n}\n.animation-delay(@delay) {\n    -webkit-animation-delay: @delay;\n    animation-delay: @delay;\n}\n.animation-iteration-count(@iteration-count) {\n    -webkit-animation-iteration-count: @iteration-count;\n    animation-iteration-count: @iteration-count;\n}\n.animation-direction(@direction) {\n    -webkit-animation-direction: @direction;\n    animation-direction: @direction;\n}\n\n.transition(@arguments: none) {\n    -webkit-transition: @arguments;\n    -moz-transition: @arguments;\n    -o-transition: @arguments;\n}\n\n.transition(@transition: none) {\n    -webkit-transition: @transition;\n    transition: @transition;\n}\n\n.transition-property(@transition-property: none) {\n    -webkit-transition-property: @transition-property;\n    transition-property: @transition-property;\n}\n\n.transition-delay(@transition-delay) {\n    -webkit-transition-delay: @transition-delay;\n    transition-delay: @transition-delay;\n}\n\n.transition-duration(@transition-duration) {\n    -webkit-transition-duration: @transition-duration;\n    transition-duration: @transition-duration;\n}\n\n.transition-timing-function(@timing-function) {\n    -webkit-transition-timing-function: @timing-function;\n    transition-timing-function: @timing-function;\n}\n\n.transition-transform(@transition) {\n    -webkit-transition: -webkit-transform @transition;\n    -moz-transition: -moz-transform @transition;\n    -o-transition: -o-transform @transition;\n    transition: transform @transition;\n}\n\n.no-text-shadow() {\n    -o-text-shadow: none;\n    -moz-text-shadow: none;\n    -khtml-text-shadow: none;\n    -webkit-text-shadow: none;\n    text-shadow: none;\n}\n\n.blur(@val: 7px) {\n    -o-filter: blur(@val);\n    -moz-filter: blur(@val);\n    -ms-folter: blur(@val);\n    -webkit-filter: blur(@val);\n    filter: blur(@val);\n}\n\n.no-wrap() {\n    text-wrap: none;\n    white-space: -moz-nowrap;\n    white-space: nowrap;\n    word-wrap: normal;\n}\n\n.box-sizing(@val: border-box) {\n    -moz-box-sizing: @val;\n    -webkit-box-sizing: @val;\n    box-sizing: @val;\n}\n\n.autoresize() {\n    zoom: 1;\n    &:after {\n        clear: both;\n        content: '';\n        display: block;\n        height: 0;\n        //visibility: hidden;\n    }\n}\n\n.crop-text() {\n    .no-wrap();\n    overflow: hidden;\n    -o-text-overflow: ellipsis;\n    -webkit-text-overflow: ellipsis;\n    -moz-text-overflow: ellipsis;\n    text-overflow: ellipsis;\n}\n\n.box-shadow(@x: 0, @y: 1px, @blur: 0, @padding: 0, @color: rgba(0, 0, 0, 0.15)) {\n    -o-box-shadow: @arguments;\n    -moz-box-shadow: @arguments;\n    -khtml-box-shadow: @arguments;\n    -webkit-box-shadow: @arguments;\n    box-shadow: @arguments;\n}\n\n.columns(@value:2) {\n    -o-columns: @value;\n    -moz-columns: @value;\n    -khtml-columns: @value;\n    -webkit-columns: @value;\n    columns: @value;\n}\n\n.no-box-shadow() {\n    -o-box-shadow: none;\n    -moz-box-shadow: none;\n    -khtml-box-shadow: none;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n}\n\n.text-shadow(@x, @y, @blur, @color) {\n    -o-text-shadow: @arguments;\n    -moz-text-shadow: @arguments;\n    -khtml-text-shadow: @arguments;\n    -webkit-text-shadow: @arguments;\n    text-shadow: @arguments;\n}\n\n/* FLEX */\n.display-flex () {\n    display: -ms-flex;\n    display: -webkit-flex;\n    display: flex;\n}\n\n.display-inline-flex () {\n    display: -ms-inline-flex;\n    display: -webkit-inline-flex;\n    display: inline-flex;\n}\n\n.align-content (@val: stretch) {\n    -webkit-align-content: @val;\n    align-content: @val;\n}\n\n.align-items (@val: stretch) {\n    -webkit-align-items: @val;\n    align-items: @val;\n}\n\n.align-self (@val: auto) {\n    -webkit-align-self: @val;\n    align-self: @val;\n}\n\n.flex (@arguments: none) {\n    -webkit-flex: @arguments;\n    -ms-flex: @arguments;\n    flex: @arguments;\n}\n\n.flex-basis (@val: auto) {\n    -webkit-flex-basis: @val;\n    flex-basis: @val;\n}\n\n.flex-direction (@val: row) {\n    -webkit-flex-direction: @val;\n    -ms-flex-direction: @val;\n    flex-direction: @val;\n}\n\n.flex-flow (@arguments: none) {\n    -webkit-flex-flow: @arguments;\n    flex-flow: @arguments;\n}\n\n.flex-grow (@val: 0) {\n    -webkit-flex-grow: @val;\n    flex-grow: @val;\n}\n\n.flex-shrink (@val: 1) {\n    -webkit-flex-shrink: @val;\n    flex-shrink: @val;\n}\n\n.flex-wrap (@val: nowrap) {\n    -webkit-flex-wrap: @val;\n    flex-wrap: @val;\n}\n\n.justify-content (@val: flex-start) {\n    -webkit-justify-content: @val;\n    justify-content: @val;\n}\n\n.order (@val: 0) {\n    -ms-flex-order: @val;\n    -webkit-order: @val;\n    order: @val;\n}\n\n.user-select(@val: none) {\n    -moz-user-select: @val;\n    -webkit-user-select: @val;\n    -ms-user-select: @val;\n}\n\n.rotate(@degrees) {\n    -webkit-transform: rotate(@degrees);\n    -ms-transform: rotate(@degrees); // IE9 only\n    transform: rotate(@degrees);\n}\n.scale(@ratio) {\n    -webkit-transform: scale(@ratio);\n    -ms-transform: scale(@ratio); // IE9 only\n    transform: scale(@ratio);\n}\n\n.scaleX(@ratio) {\n    -webkit-transform: scaleX(@ratio);\n    -ms-transform: scaleX(@ratio); // IE9 only\n    transform: scaleX(@ratio);\n}\n\n.scaleY(@ratio) {\n    -webkit-transform: scaleY(@ratio);\n    -ms-transform: scaleY(@ratio); // IE9 only\n    transform: scaleY(@ratio);\n}\n\n.translate(@x; @y) {\n    -webkit-transform: translate(@x, @y);\n    -ms-transform: translate(@x, @y); // IE9 only\n    transform: translate(@x, @y);\n}\n\n.translateZ(@val) {\n    -webkit-transform: translateZ(@val);\n    -ms-transform: translateZ(@val); // IE9 only\n    transform: translateZ(@val);\n}\n\n.skew(@x; @y) {\n    -webkit-transform: skew(@x, @y);\n    -ms-transform: skewX(@x) skewY(@y); // See https://github.com/twbs/bootstrap/issues/4885; IE9+\n    transform: skew(@x, @y);\n}\n.translate3d(@x; @y; @z) {\n    -webkit-transform: translate3d(@x, @y, @z);\n    transform: translate3d(@x, @y, @z);\n}\n\n.rotateX(@degrees) {\n    -webkit-transform: rotateX(@degrees);\n    -ms-transform: rotateX(@degrees); // IE9 only\n    transform: rotateX(@degrees);\n}\n.rotateY(@degrees) {\n    -webkit-transform: rotateY(@degrees);\n    -ms-transform: rotateY(@degrees); // IE9 only\n    transform: rotateY(@degrees);\n}\n.perspective(@perspective) {\n    -webkit-perspective: @perspective;\n    -moz-perspective: @perspective;\n    perspective: @perspective;\n}\n.perspective-origin(@perspective) {\n    -webkit-perspective-origin: @perspective;\n    -moz-perspective-origin: @perspective;\n    perspective-origin: @perspective;\n}\n.transform-origin(@origin) {\n    -webkit-transform-origin: @origin;\n    -moz-transform-origin: @origin;\n    -ms-transform-origin: @origin; // IE9 only\n    transform-origin: @origin;\n}\n\n.opacity(@opacity) {\n    opacity: @opacity;\n    // IE8 filter\n    @opacity-ie: (@opacity * 100);\n    filter: ~\"alpha(opacity=@{opacity-ie})\";\n}\n\n.placeholder(@color) {\n    &::-moz-placeholder           { color: @color; } // Firefox\n    &:-ms-input-placeholder       { color: @color; } // Internet Explorer 10+\n    &::-webkit-input-placeholder  { color: @color; } // Safari and Chrome\n}\n\n// Mixin\n.center-block() {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n// Mixins\n.size(@width; @height) {\n    width: @width;\n    height: @height;\n}\n.square(@size) {\n    .size(@size; @size);\n}\n\n.text-overflow() {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.font-size(@size) {\n    font-size: unit((@size / @em-size), rem);\n}\n\n.appearance(@val) {\n    -webkit-appearance: @val;\n    -moz-appearance: @val;\n}\n\n.viewport-width() {\n    width: @min-width-desktop;\n\n    @media only screen and (min-device-width: @min-tablet-device) and (max-device-width: @max-tablet-device) {\n        width: @min-width-tablet;\n    }\n\n    // IPhone Plus\n    @media only screen and (min-device-width: @min-mobile-device) and (max-device-width: @max-mobile-device) {\n        width: @min-width-mobile;\n    }\n}\n\n#size() {\n\n    &.extra-short {\n        width: @gutter * 5 !important;\n    }\n\n    &.short {\n        width: @gutter * 10 !important;\n    }\n\n    &.middle {\n        width: @gutter * 20 !important;\n    }\n\n    &.long {\n        width: @gutter * 30 !important;\n    }\n\n    &.extra-long {\n        width: @gutter * 40 !important;\n    }\n\n    &.wide {\n        width: 100% !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
